import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { get } from 'lodash';
import { NoWrapContainer } from 'src/components/GlobalTooltip/GlobalTooltip';
import { Tooltip } from 'antd';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { EnumTablePosition } from 'src/types/common/common';
import { maskPhone, maskEmail, maskFullName } from '@/src/tools/mask';

import css from './css.module.less';
import React from 'react';

export const convertQuery = (filter) => {
  const re: any = {};
  if (filter.customerTags) {
    if (filter.customerTags.length > 0) {
      re.customerTags = filter.customerTags.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }

  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};
export const filterList = (taggedList, { getI18n }) => {
  return [
    {
      type: EnumFilterType.MultipleSelection,
      dropdownProps: { name: getI18n('general.tags') },
      keyWord: 'customerTags',
      options: taggedList.map((item) => ({
        label: item.name,
        value: item.uuid,
      })),
      searchable: true,
    },
  ];
};

export const generateColumns = (
  getI18n,
  onDelete?: (index: number) => void,
  disabled?: boolean,
) => {
  const baseCols = [
    {
      minWidth: 150,
      className: css.modalRow,
      title: getI18n('general.customerID'),
      key: 'CustomerID',
      default: true,
      sorter: (a, b) => {
        const valueA = get(a, 'uuid') || '';
        const valueB = get(b, 'uuid') || '';
        return valueA.localeCompare(valueB);
      },
      childGenerate: (a, record, index) => {
        const name = get(record, 'uuid');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      sorter: (a, b) => {
        const valueA = get(a, 'fullName') || '';
        const valueB = get(b, 'fullName') || '';
        return valueA.localeCompare(valueB);
      },
      title: getI18n('general.customer.fullName'),
      className: css.modalRow,
      key: 'FullName',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'fullName');
        const lastName = get(record, 'lastName');
        const firstName = get(record, 'firstName');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>
              {maskFullName(lastName, firstName, name)}
            </Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.mobileNumber'),
      className: css.modalRow,
      key: 'areaCode',
      default: true,
      childGenerate: (a, record, index) => {
        const areaCode = get(record, 'areaCode') || '';
        const number = get(record, 'mobile') || '';
        const display = areaCode + ' ' + number || '';
        const displayMask = areaCode + ' ' + maskPhone(number) || '';
        return (
          <NoWrapContainer>
            <Tooltip title={display}>{displayMask}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.customer.email'),
      className: css.modalRow,
      key: 'email',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'email');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{maskEmail(name)}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
    {
      minWidth: 150,
      title: getI18n('general.remarks'),
      className: css.modalRow,
      key: 'remarks',
      default: true,
      childGenerate: (a, record, index) => {
        const name = get(record, 'remarks');
        return (
          <NoWrapContainer>
            <Tooltip title={name}>{name}</Tooltip>
          </NoWrapContainer>
        );
      },
    },
  ];

  if (onDelete) {
    return [
      ...baseCols,
      {
        titleGenerate: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        position: EnumTablePosition.mid,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          return (
            <Actions
              disabled={disabled}
              onDelete={() => {
                if (onDelete && !disabled) {
                  onDelete(index);
                }
              }}
            />
          );
        },
        width: 104,
      },
    ];
  } else {
    return baseCols;
  }
};
